<template>
	<div class="page-main">
		<nav-bar :border="false" :left-arrow="true" @click-left="back" title="星礼包"></nav-bar>

		<div v-if="srkit" class="section">
			<div class="section-header">
				<div class="section-title">{{ srkit.title }}</div>
				<div class="section-desc">{{ srkit.description }}</div>
			</div>

			<div class="shelf" v-for="(shelf, sIdx) in srkit.shelfs" :key="sIdx" :style="{background: shelf.shelfBackgroundColourZhForApp || '#fff'}">
				<img v-if="shelf.shelfTitleImageUrl" :src="shelf.shelfTitleImageUrl" class="shelf-banner"/>
				<div class="shelf-title" v-if="shelf.shelfTitle">{{ shelf.shelfTitle }}</div>

				<div class="card-item" v-for="(card, cIdx) in shelf.cards" :key="cIdx">
					<img class="card-img" :src="card.imageUrl"/>
					<div class="card-info">
						<div class="card-name">{{ card.title }}</div>
						<div class="card-desc">{{ card.description }}</div>
						<div class="card-tags">
							<span v-if="card.discountTag" class="tag">{{ card.discountTag }}</span>
						</div>
						<div class="card-price">
							<span class="price">¥{{ (card.purchaseAmount / 100).toFixed(2) }}</span>
						</div>
					</div>
					<div class="card-btn" :class="{'sold-out': card.soldOut}" @click="buy(card)">
						{{ card.soldOut ? '已售罄' : '购买' }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {NavBar} from "vant";
	import {GiftList2, PayCard2} from "@/api";
	export default {
		data() {
			return {
				srkit: null,
			}
		},
		created() {
			this.init();
		},
		methods: {
			back() {
				this.$router.back();
			},
			async init() {
				let {data} = await GiftList2();
				this.srkit = data.srkit || null;
			},
			buy(card) {
				if (card.soldOut) return;
				let info = {
					consumeNum: 1,
					name: card.title,
					price: card.purchaseAmount,
					sku: card.sku
				};
				PayCard2(info).then(d => {
					this.$router.replace({
						name: 'pay',
						query: {data: JSON.stringify(d.data)}
					});
				});
			}
		},
		components: {NavBar}
	}
</script>

<style lang="scss" scoped>
.page-main {
	min-height: 100vh;
	background: linear-gradient(180deg, #f5f7fa 0%, #e4e7ed 100%);
}

::v-deep .van-nav-bar {
	background: #fff;

	.van-nav-bar__title {
		color: #333 !important;
		font-size: 28px;
	}

	.van-icon {
		color: #333 !important;
	}
}

.section-header {
	padding: 28px 24px 16px;
}

.section-title {
	font-size: 32px;
	font-weight: 700;
	color: #303133;
}

.section-desc {
	font-size: 22px;
	color: #909399;
	margin-top: 8px;
}

.shelf {
	margin: 0 24px 20px;
	border-radius: 20px;
	overflow: hidden;
	background: #fff;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.shelf-banner {
	display: block;
	width: 100%;
}

.shelf-title {
	font-size: 26px;
	font-weight: 600;
	color: #303133;
	padding: 20px 24px 8px;
}

.card-item {
	display: flex;
	align-items: center;
	padding: 20px 24px;
	border-bottom: 1px solid #f2f6fc;

	&:last-child {
		border-bottom: none;
	}
}

.card-img {
	width: 80px;
	height: 80px;
	border-radius: 12px;
	object-fit: cover;
	margin-right: 20px;
	flex-shrink: 0;
}

.card-info {
	flex: 1;
	min-width: 0;
}

.card-name {
	font-size: 26px;
	font-weight: 600;
	color: #303133;
	margin-bottom: 6px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.card-desc {
	font-size: 20px;
	color: #909399;
	margin-bottom: 8px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.card-tags {
	margin-bottom: 8px;
}

.tag {
	display: inline-block;
	font-size: 18px;
	color: #059669;
	background: #e8f8f2;
	padding: 4px 12px;
	border-radius: 8px;
}

.card-price {
	.price {
		font-size: 28px;
		font-weight: 700;
		color: #e6a23c;
	}
}

.card-btn {
	min-width: 100px;
	height: 56px;
	line-height: 56px;
	border-radius: 28px;
	background: linear-gradient(135deg, #059669, #10b981);
	color: #fff;
	text-align: center;
	font-size: 24px;
	font-weight: 600;
	padding: 0 20px;
	flex-shrink: 0;
	margin-left: 16px;
	transition: transform 0.2s;

	&:active {
		transform: scale(0.95);
	}

	&.sold-out {
		background: #c0c4cc;
		pointer-events: none;
	}
}
</style>
